import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import ArrowDownSvg from 'assets/svgr-icons/Arrow_Down.svg'

const buttonOutlineStyles = css`
  &::before {
    content: ' ';
    position: absolute;
    z-index: -1;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 1px solid rgba(56, 125, 255, 0.16);
    border-radius: 5px;
  }
`

export const ImageStylesButton = styled.div<{
  $isToggled: boolean
  $disabled?: boolean
}>`
  position: relative;
  width: 100%;
  height: 40px;
  padding: 6px 12px;

  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  transition: all 0.3s;

  ${({ $isToggled, $disabled }) =>
    $isToggled
      ? css`
          border-color: ${COLORS.primaryDark};
          ${buttonOutlineStyles}
        `
      : !$disabled
        ? css`
            &:hover {
              border-color: ${COLORS.secondarySemiLight};
              ${buttonOutlineStyles}
            }
          `
        : css`
            cursor: default;
          `}
`

export const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SelectedStyleImg = styled.div`
  width: 28px;
  height: 28px;

  overflow: hidden;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const Arrow = styled(ArrowDownSvg)`
  transform: rotate(-90deg);
  fill: ${COLORS.secondarySemiDark};
`
export const StyleImage = styled.img<{
  $isLoading?: boolean
}>`
  object-fit: cover;
  /* max-width: 100%; for real data as it must be square */
  /* max-height: 100%; */
  height: 100%; // todoA dlete after real data just let max-width: 100%; max-height: 100%;

  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
`
